module.exports = __webpack_public_path__ + "img/nav_b1_img2.fa4cdb88.png";